import "./node_modules/bootstrap/dist/css/bootstrap.min.css"
import ReactDOM from "react-dom"

export function replaceHydrateFunction() {
  return (element, container, callback) => {
    ReactDOM.render(element, container, callback)
  }
}
